// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2qe2W","componentStack":"styles_componentStack__2fiuB"};